import React from "react"

import { createIcon } from "@chakra-ui/react"

export const ErrorIcon = createIcon({
  displayName: "ErrorIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <circle cx="12" cy="12" r="12" fill="fill" />
      <path
        fill={"currentColor"}
        d="M15.59 7L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41L15.59 7Z"
      />
    </>
  ),
})
